/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './styles.scss';


const propTypes = {
  options: React.PropTypes.array.isRequired,
  values: React.PropTypes.array.isRequired,
  onChange: React.PropTypes.func.isRequired,
  disabled: React.PropTypes.bool,
  multiple: React.PropTypes.bool,
  bsSize: React.PropTypes.string,
  bsStyle: React.PropTypes.string,
};

const defaultProps = {
  bsStyle: 'aisz-primary',
  multiple: false,
  disabled: false,
  bsSize: null,
};

class InlineSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      values: props.values,
      disabled: props.disabled,
    };
    this.toggleSelect = this.toggleSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { disabled, values } = nextProps;
    if (disabled !== this.props.disabled) {
      this.setState({ disabled });
    }
    if (values !== this.props.values) {
      this.setState({ values });
    }
  }

  active(opt) {
    return this.state.values.some(v => (v === opt.value));
  }

  toggleSelect(value) {
    const { multiple = false, onChange } = this.props;
    let { values } = this.state;
    if (multiple) {
      if (values.includes(value)) {
        values = _.filter(values, v => (v !== value));
      } else {
        values.push(value);
      }
    } else {
      values = [value];
    }
    onChange(values);
  }

  render() {
    const { bsStyle, bsSize, options } = this.props;
    const { disabled } = this.state;
    const opts = options.map(opt => (
      <Button
        key={opt.value}
        bsSize={bsSize}
        bsStyle={this.active(opt) ? bsStyle : 'aisz-light'}
        onClick={() => this.toggleSelect(opt.value)}
        disabled={disabled}
      >
        {opt.label}
      </Button>
    ));

    return (
      <div className={styles.inselect}>
        {opts}
      </div>
    );
  }
}

InlineSelect.propTypes = propTypes;
InlineSelect.defaultProps = defaultProps;

export default InlineSelect;




// WEBPACK FOOTER //
// ./src/components/InlineSelect/index.jsx